import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { router } from './router';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

const root = document.getElementById('root');

if (!root) {
  throw new Error('Missing root element');
}

const container = root;

async function bootstrap() {
  // `VITE_API_MOCKS=true make dev` serves the API from msw. The branch is removed from builds.
  if (import.meta.env.DEV && import.meta.env.VITE_API_MOCKS === 'true') {
    const { startMocks, mockStore } = await import('./mocks/browser');
    await startMocks();
    if (window.location.pathname === '/__mocks/stripe') {
      const { MockStripePage } = await import('./mocks/MockStripePage');
      createRoot(container).render(<MockStripePage store={mockStore} />);
      return;
    }
    if (window.location.pathname === '/__mocks/stripe-receipt') {
      const { MockStripeReceipt } = await import('./mocks/MockStripePage');
      createRoot(container).render(<MockStripeReceipt store={mockStore} />);
      return;
    }
  }
  createRoot(container).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}

void bootstrap();
